/* Blocker & indicator positioning */

.af-progress__blocker {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
}

.af-progress__indicator {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
}
